import React from "react";
import { Link } from "react-router-dom";
import { Heart, Sparkles, Shirt, Wrench } from "lucide-react";
import { motion } from "framer-motion";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import "./ServicesTeaser.css";

const ServicesTeaser = () => {
  const [ref, isVisible] = useScrollAnimation(0.15);

  const services = [
    {
      icon: Heart,
      title: "Bridal Couture",
      description:
        "Exquisite bridal wear that makes your special day unforgettable with stunning designs.",
      link: "/services",
    },
    {
      icon: Sparkles,
      title: "Aari Work",
      description:
        "Intricate hand embroidery that adds traditional elegance to modern designs.",
      link: "/services",
    },
    {
      icon: Wrench,
      title: "Alterations & Repairs",
      description:
        "Expert alterations to ensure your garments fit perfectly and last longer.",
      link: "/services",
    },
    {
      icon: Shirt,
      title: "All Type of Stitching",
      description:
        "Comprehensive stitching services for all your fashion needs and occasions.",
      link: "/services",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  const titleVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="services-teaser-section" ref={ref}>
      <div className="services-teaser-container">
        <motion.h2
          className="services-teaser-title"
          variants={titleVariants}
          initial="hidden"
          animate={isVisible ? "visible" : "hidden"}
        >
          Our Services
        </motion.h2>
        <motion.p
          className="services-teaser-subtitle"
          variants={titleVariants}
          initial="hidden"
          animate={isVisible ? "visible" : "hidden"}
        >
          Expert craftsmanship for every occasion
        </motion.p>

        <motion.div
          className="services-grid"
          variants={containerVariants}
          initial="hidden"
          animate={isVisible ? "visible" : "hidden"}
        >
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <motion.div
                key={index}
                className="service-card"
                variants={cardVariants}
                whileHover={{
                  y: -12,
                  transition: { duration: 0.3 },
                }}
              >
                <motion.div
                  className="service-icon"
                  whileHover={{
                    scale: 1.15,
                    rotate: 360,
                    transition: { duration: 0.6 },
                  }}
                >
                  <IconComponent size={32} />
                </motion.div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <Link to={service.link} className="service-link">
                  Learn More
                </Link>
              </motion.div>
            );
          })}
        </motion.div>

        <motion.div
          className="services-teaser-footer"
          initial={{ opacity: 0, y: 30 }}
          animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <Link to="/services" className="services-view-all">
            View All Services
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesTeaser;
